module.exports = "/src/views/player/reports/strela.png";